import { render } from "./SearchBoardHead.vue?vue&type=template&id=134ff7a8&scoped=true"
import script from "./SearchBoardHead.vue?vue&type=script&lang=js"
export * from "./SearchBoardHead.vue?vue&type=script&lang=js"

import "./SearchBoardHead.vue?vue&type=style&index=0&id=134ff7a8&lang=sass&scoped=true"

import exportComponent from "C:\\yb\\work\\website\\yunyu2021\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-134ff7a8"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
